/**
 * Blossom Wings, "free delivery" links (owner request 21 Oct 2026).
 * Every visible "free delivery" phrase (EN + AR) becomes a highlighted, underlined link to the
 * Free delivery page (/pages/free-delivery, locale-prefixed by layout/theme.liquid).
 * Skips text that is already inside a link, button, form control, summary, script/style,
 * or any element marked [data-no-fd]. Watches the DOM so the cart drawer messages
 * (rewritten by assets/bw-cart.js) and other late content get the link too.
 * Links written in Liquid use the same class (.bw-fd) and are left alone.
 */
(function () {
  'use strict';
  var script = document.currentScript;
  var url = (script && script.dataset.fdUrl) || '/pages/free-delivery';
  var label = (script && script.dataset.fdLabel) || 'See free delivery picks';
  if (/\/pages\/free-delivery\/?$/.test(location.pathname)) return;

  // Longest phrases first, so "توصيل طلبك مجاني" wins over "توصيل".
  var RX = /(free delivery|delivered free|ships? free|توصيل طلبك مجاني|التوصيل مجانيا|التوصيل مجاني|توصيل مجاني)/gi;
  var SKIP = /^(A|BUTTON|SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT|SELECT|OPTION|SUMMARY|LABEL|TITLE|SVG|TEMPLATE)$/;

  function skipped(node) {
    for (var el = node.parentNode; el && el !== document.body; el = el.parentNode) {
      if (el.nodeType !== 1) continue;
      if (SKIP.test(el.nodeName.toUpperCase())) return true;
      if (el.hasAttribute('data-no-fd') || el.isContentEditable) return true;
    }
    return false;
  }

  function linkText(node) {
    var text = node.nodeValue;
    RX.lastIndex = 0;
    if (!text || !RX.test(text)) return;
    if (skipped(node)) return;
    RX.lastIndex = 0;
    var frag = document.createDocumentFragment();
    var last = 0, m;
    while ((m = RX.exec(text))) {
      if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
      var a = document.createElement('a');
      a.className = 'bw-fd';
      a.href = url;
      a.title = label;
      a.textContent = m[0];
      frag.appendChild(a);
      last = m.index + m[0].length;
    }
    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 3) { linkText(root); return; }
    if (root.nodeType !== 1 || SKIP.test(root.nodeName.toUpperCase())) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null);
    var nodes = [], n;
    while ((n = walker.nextNode())) nodes.push(n);
    nodes.forEach(linkText);
  }

  function addStyles() {
    if (document.getElementById('bw-fd-styles')) return;
    var s = document.createElement('style');
    s.id = 'bw-fd-styles';
    s.textContent =
      'a.bw-fd{color:inherit !important;font-weight:inherit;text-decoration:underline !important;' +
      'text-decoration-color:#F05C85 !important;text-decoration-thickness:2px;text-underline-offset:3px;' +
      'background:linear-gradient(transparent 58%,rgba(240,92,133,.28) 58%);border-radius:2px;padding:0 1px;cursor:pointer}' +
      'a.bw-fd:hover{background:rgba(240,92,133,.28)}' +
      'a.bw-fd:focus-visible{outline:2px solid #4D93C7;outline-offset:2px}';
    document.head.appendChild(s);
  }

  function start() {
    addStyles();
    scan(document.body);
    if (!('MutationObserver' in window)) return;
    var queue = [], busy = false;
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.type === 'characterData') queue.push(r.target);
        else r.addedNodes.forEach(function (x) { queue.push(x); });
      });
      if (busy) return;
      busy = true;
      requestAnimationFrame(function () {
        var q = queue; queue = []; busy = false;
        q.forEach(function (x) { if (x.isConnected) scan(x); });
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
